// extracted by mini-css-extract-plugin
export default {"groupProduct":"product_groupProduct__Xj-2D","actions":"product_actions__usMER","data":"product_data__E3ObS"};